import ConfirmationModalBase from "@/components/common/modals/confirmation-modal-base";

export type ConfirmationModalMode =
  | "delete-section"
  | "cancel"
  | "save-draft"
  | "publish"
  | "delete-question";

interface Props {
  isOpen: boolean;
  mode: ConfirmationModalMode;
  onClose: () => void;
  onAccept: () => void;
  isLoading?: boolean;
}

const FAQConfirmationModal = ({
  mode,
  isOpen,
  onClose,
  onAccept,
  isLoading = false,
}: Props) => {
  const getModalContent = () => {
    switch (mode) {
      case "delete-section":
        return {
          title: "Eliminar sección",
          description:
            "¿Estás seguro de que deseas eliminar esta sección? Se eliminarán todas las preguntas asociadas también",
          acceptText: "Eliminar sección",
          acceptVariant: "danger-secondary" as const,
        };
      case "cancel":
        return {
          title: "Salir sin guardar",
          description:
            "¿Estás seguro de que deseas salir? Todos los cambios que hayas realizado se perderán.",
          acceptText: "Salir sin guardar",
          acceptVariant: "danger-secondary" as const,
        };
      case "delete-question":
        return {
          title: "Eliminar pregunta",
          description: "¿Estás seguro de eliminar esta pregunta?",
          acceptText: "Eliminar pregunta",
          acceptVariant: "danger-secondary" as const,
        };
      case "save-draft":
        return {
          title: "Guardar como borrador",
          description:
            "¿Estás seguro de que deseas guardar los cambios de las preguntas frecuentes como borrador? Podrás publicarlos más tarde.",
          acceptText: "Guardar borrador",
          acceptVariant: "default" as const,
        };
      case "publish":
        return {
          title: "Publicar cambios",
          description:
            "¿Estás seguro de que deseas publicar los cambios? Las preguntas frecuentes actualizadas estarán disponibles inmediatamente para los usuarios del Portal SDT de tu institución.",
          acceptText: "Publicar",
          acceptVariant: "default" as const,
        };
      default:
        return {
          title: "",
          description: "",
          acceptText: "",
          acceptVariant: "default" as const,
        };
    }
  };

  const { title, description, acceptText, acceptVariant } = getModalContent();

  return (
    <ConfirmationModalBase
      isOpen={isOpen}
      onClose={onClose}
      onAccept={onAccept}
      title={title}
      description={description}
      acceptText={acceptText}
      acceptVariant={acceptVariant}
      isLoading={isLoading}
    />
  );
};

export { FAQConfirmationModal };
